import { useState } from "react";
import { Popover, Button } from "antd";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/slices/userslice";
import api from "../../config/axiosInstance";
import ActionModal from "../actionModal";

import { CgProfile } from "react-icons/cg";
import { BiLogOutCircle } from "react-icons/bi";

function ProfilePopup() {
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [logoutLoading, setLogoutLoading] = useState(false);

  const User = useSelector((state: any) => state.User.user);

  const logOut = async () => {
    setLogoutLoading(true);
    try {
      await api.post("auth/logout");
    } catch (e) {}
    dispatch(logout({}));
    navigation("/");
  };

  const popovercontent = (
    <div className="popovercontent">
      <CgProfile size={50} color="#0055a6" />
      <div className="username">{User?.username}</div>
      <div className="headerDiscriptioncanvas">{User?.email}</div>
      <br />
      <Button block type="primary" onClick={() => navigation("/Auth/profile")}>
        Manage Profile
      </Button>
      <div style={{ margin: 5 }} />
      <Button block danger onClick={() => setShowLogoutModal(true)}>
        Logout
      </Button>
    </div>
  );
  return (
    <>
      <Popover content={popovercontent} trigger="click">
        <div style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}>
          <CgProfile size={35} color="grey"/>
        </div>
      </Popover>
      <ActionModal
        visible={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
        onOk={logOut}
        loading={logoutLoading}
        icon={<BiLogOutCircle size={40} color="#ff4d4f" />}
        text1="Are you sure you want to logout?"
      />
    </>
  );
}

export default ProfilePopup;
